export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		value: value
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function setFullPageLoading( value ) {
	return {
		type: 'SET_FULL_PAGE_LOADING',
		payload: value
	}
}

export function disableScroll() {
	return {
		type: 'DISABLE_SCROLL'
	}
}

export function enableScroll() {
	return {
		type: 'ENABLE_SCROLL'
	}
}

export function setAccountMenuOpenState( payload ) {
	return {
		type: 'SET_ACCOUNT_MENU_OPEN_STATE',
		payload
	}
}

export function setHeaderNotificationsOpenState( payload ) {
	return {
		type: 'SET_HEADER_NOTIFICATIONS_OPEN_STATE',
		payload
	}
}
